import { Injectable } from '@angular/core';
import { AnnotationOutput } from '../../../team-apis/otterdam/outputs/annotation-output';
import { CuboidHelper } from '../mesh/cuboid/cuboid-helper';
import {
  AbstractShortcutTransformService,
  getShortcutNameWithoutTransformModifier,
  shouldDoSmallTransform,
} from './abstract-shortcut-transform.service';
import {
  TranslationShortcut,
  translationShortcuts,
} from './transform-shortcuts';

@Injectable()
export class ShortcutTranslationService extends AbstractShortcutTransformService {
  constructor() {
    super(translationShortcuts);
  }

  // eslint-disable-next-line complexity -- we need two cases per X, Y, Z axis,complexity
  protected transformCuboid(
    cuboid: CuboidHelper,
    shortcut: TranslationShortcut,
    sourceOutput: AnnotationOutput,
  ) {
    const stepSize = shouldDoSmallTransform(shortcut) ? 0.01 : 0.1;
    switch (getShortcutNameWithoutTransformModifier(shortcut)) {
      case 'nudgeUp':
        cuboid.box.translateY(-stepSize);
        break;
      case 'nudgeDown':
        cuboid.box.translateY(stepSize);
        break;
      case 'nudgeLeft':
        cuboid.box.translateX(stepSize);
        break;
      case 'nudgeRight':
        cuboid.box.translateX(-stepSize);
        break;
      case 'nudgeInwards':
        cuboid.box.translateZ(-stepSize);
        break;
      case 'nudgeOutwards':
        cuboid.box.translateZ(stepSize);
    }

    this.store.updateFocusedLocationFromCuboidMesh(cuboid.box);
    this.trackTransform(cuboid, shortcut, 'translate', sourceOutput);
  }
}
